export default __webpack_public_path__ + "static/media/playStore.f6647c00.svg";